import React, { useState, useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import {
    makeStyles,
    Box,
} from '@material-ui/core';
import {
    IconPin,
    IconUnpin,
    IconPapelera,
    Dialog,
    Link,
    api,
    PortalContext
} from '@portal/arq-portal-core';
import { useSWRConfig } from 'swr';

import { FavoritosContext } from '../context/FavoritosContext';
import { CustomTooltip } from './CustomTooltip';

const useEstilos = makeStyles(() => ({
    titulo: {
        color: '#555'
    },
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginRight: '20px',
        width: 'calc(100% - 20px)',
        '& .MuiBox-root': {
            width: 'calc(100% - 45px)',
        },
        '&:hover': {
            cursor: 'default',
            '& $titulo': {
                fontWeight: 'bold'
            },
            '& $hoverIconos': {
                opacity: 1,
            }
        }
    },
    iconos: {
        display: 'flex',
        cursor: 'pointer'
    },
    hoverIconos: {
        opacity: 0,
    }
}));



interface Props {
    enlace: any;
}

export const EnlaceFavorito = ({enlace}: Props) => {
    const clases = useEstilos();
    const [mostrarModal, setMostrarModal] = useState(false);
    const { user } = useContext(PortalContext);
    const { mutate } = useSWRConfig();
    const { setEnlaceClick , favoritosSWRKey: favoritosKey, favoritosID, actualizarIdClick} = useContext(FavoritosContext);
  
    const eliminar = () => {
        mutate(["favoritos", user?.id], ()=>api.post("/be/favsdel/", {Entrada:{Url: enlace.Url, Tipo: 'Favoritos'}}), false);
    }

    const manejarAccesoRapido = () => {
        mutate([favoritosKey, user?.id], api.post("/be/favschg/", {Entrada:{Url: enlace.Url}})
        .then((data:any)=>{
            // By changing the answer every time we force to redo the print of the "Favoritos", which
            // it is the behavior we expect to detect in the upper level (Favoritos component level) the error that will be missed
            // due to the reload if we tread it here.
            data.Random = Math.floor(Math.random() * 101);
            data.favoritosID = favoritosID;
            return(data)}
            )
            , false);
    };

    const manejarEliminar = () => {
        if (enlace.AccesoRapido) {
            setMostrarModal(true);
        } else {
            eliminar();
        }
    };

    const manejarCierre = () => {
        setMostrarModal(false);
    };

    const manejarAceptar = () => {
        eliminar();
    };


    const simplificarCIA = (titulo: string) => {
    
        titulo = titulo.replaceAll("SPU", "PU");
        titulo = titulo.replaceAll("SBI", "SB");
        
        return titulo;
    }

    return (
        <div className={clases.root}>
            <Box onClick={() => setEnlaceClick(true)}>
                <Link to={enlace.TargetUrl} actualizarIdClick={actualizarIdClick} >
                    <CustomTooltip title={enlace.TargetUrl} placement="bottom-start">
                        <Typography variant='caption' component='div' classes={{ root: clases.titulo }} >{simplificarCIA(enlace.nombre)}</Typography>
                    </CustomTooltip>
                </Link>
            </Box>
            <div className={clases.iconos}>
                {enlace.AccesoRapido &&
                    <CustomTooltip title="Eliminar acceso rápido">
                        <span>
                            <IconUnpin fontSize='small' onClick={() => manejarAccesoRapido()} />
                        </span>
                    </CustomTooltip>
                }
                <div className={clases.hoverIconos}>
                    {!enlace.AccesoRapido &&
                    <CustomTooltip title="Añadir acceso rápido">
                        <span>
                            <IconPin fontSize='small' onClick={() => manejarAccesoRapido()} />
                        </span>
                    </CustomTooltip>
                        
                    }
                    <IconPapelera fontSize='small' onClick={() => manejarEliminar()} />
                </div>
            </div>
            {
                mostrarModal &&
                <Dialog
                    title="Eliminar favorito"
                    open={mostrarModal}
                    manejarCierre={manejarCierre}
                    guardar={manejarAceptar}
                    tituloAceptar="Eliminar"
                >
                    <p>Este Favorito está marcado como Acceso Rápido, al eliminarlo también se eliminará el Acceso Rápido. ¿Estás seguro de que quieres eliminarlo?</p>
                </Dialog>
            }
        </div>
    )
}